<template>
	<div>
		<navigation msg="人员管理/下级平台管理" />
		<router-view></router-view>
	</div>
</template>

<script>
	import navigation from '@/components/comm/navigation.vue'
	export default{
		data(){
			return {}
		},
		components:{
			navigation
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/plat/home.vue